import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import Analytics from '../common/Analytics';
import IntegrationGuide from '../common/IntegrationGuide';
import SponsorContainer from '../sponsorship/SponsorContainer';
import XIcon from '../lib/XIcon';
import Callout from '../lib/Callout';
import { Table } from 'react-bootstrap';

const Activate = (props) => {
    const account = props?.match?.params?.address;
    Analytics.event({category: 'AccountActivation', action: 'AccountActivation', label: account});

    useEffect(() => {
        Analytics.pageview();
    });

	return (
		<div>
				<Helmet>
					<title>Activate account | XRPSCAN</title>
				</Helmet>
				<Row>
					<Col>
						<IntegrationGuide/>
					</Col>
				</Row>
				<Row>
                    <Col xs={12} md={12}>
						<SponsorContainer />
					</Col>
				</Row>

				<Row>
					<Col xs={12} md={12}>
						<Card>
							<Card.Body>
								<Card.Title>
									<XIcon icon='circle-dollar-to-slot' />
									<span className="pl-2">Activate account</span>
								</Card.Title>

                                <Row>
                                    <Col xs={12} md={12}>
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th className="data-header">Address</th>
                                                <th>
                                                    <code>{account}</code>
                                                </th>
                                                </tr>
                                        </thead>
                                    </Table>
                                    </Col>
                                </Row>

                                <Callout title="INACTIVE ACCOUNT" variant="primary">
                                    <span className='ml-2'>
                                        This account is inactive. Send a minimum <strong>1 XRP</strong> to this address
                                        to activate or buy XRP below to activate automatically.
                                    </span>
                                    <hr/>
                                    <span>
                                        In order to hold XRP in an account, it must first be activated with a minimum of
                                        1 XRP. Once the XRP account is active, 1 XRP will be used to maintain the
                                        network's reserve requirement. This amount cannot be spent or withdrawn.&nbsp;
                                        <a
                                            href="https://help.xaman.app/app/getting-started-with-xaman/how-to-activate-a-new-xrpl-account"
                                            target="_blank"
                                            rel="noopener noreferrer nofollow"
                                        >Read more &rarr;</a>
                                    </span>
                                </Callout>

                                <Row>
                                <Col xs={12} md={12}>
                                    <Card className="text-center">
                                    <Card.Header>
                                        <Card.Title>
                                            Account activation: Terms and conditions
                                        </Card.Title>
                                    </Card.Header>

                                    <Card.Body>
                                        <Form.Group id="fgrp1">
                                            <Form.Check type="checkbox" id="form-tnc-redirect" label="I understand that I will be redirected to Moonpay website to complete KYC and buy XRP for activating this wallet." />
                                        </Form.Group>
                                        <Form.Group id="fgrp2">
                                            <Form.Check type="checkbox" id="form-tnc-irreversible" label="I understand that XRP transactions are irreversible. I am responsible for entering correct details while buying XRP." />
                                        </Form.Group>
                                        <Form.Group id="fgrp3">
                                            <Form.Check type="checkbox" id="form-tnc-support" label="I understand that I am buying XRP from Moonpay. If I require any support, I will contact Moonpay support directly." />
                                        </Form.Group>
                                    </Card.Body>

                                    <Card.Footer>
                                        <Button
                                            variant="primary"
                                            size="lg"
                                            href="https://api.xrpscan.com/api/v1/campaign/moonpayactivation"
                                            target="_blank"
                                            rel="noopener nofollow"
                                        >Activate via Moonpay &rarr;</Button>
                                    </Card.Footer>
                                    </Card>
                                </Col>
                                </Row>
							</Card.Body>
						</Card>
					</Col>
				</Row>

		</div>
	);
}

export default Activate;